module.exports = __webpack_public_path__ + "f2aef608bb51e05f9afee50dc26c2e5c.svg";